var map = {
	"./01_header_bg.jpg": "Y/A5",
	"./02_01_gate.png": "+oea",
	"./02_02_compressor.png": "r/P9",
	"./02_03_boost.png": "JiD7",
	"./02_04_distortion.png": "sNr/",
	"./02_05_eq.png": "FSy9",
	"./02_06_modulation.png": "B1qJ",
	"./02_07_delay.png": "dcOX",
	"./02_08_reverb.png": "PZUR",
	"./03_01_trichorus.png": "g1g7",
	"./03_02_multi_comp.png": "NZ8P",
	"./03_03_wah.png": "6b3Y",
	"./03_04_mega_tap.png": "ZiBy",
	"./03_05_echorex.png": "SniY",
	"./03_06_advanced_comp.png": "XfUY",
	"./03_07_rotary.png": "a4z1",
	"./03_08_spring.png": "D0Jm",
	"./04_tone_cloud.jpg": "nKDe",
	"./amp-acoustic.png": "2ctc",
	"./amp-bass.png": "0V8m",
	"./amp-crunch.png": "RQdG",
	"./amp-higain.png": "UN3g",
	"./amp-lowgain.png": "+19E",
	"./amp/01-acoustic-sim.jpg": "J43A",
	"./amp/02-high-gain.jpg": "xAUT",
	"./amp/03-crunch.jpg": "0B5P",
	"./amp/04-low-gain.jpg": "gCAY",
	"./amp/Acoustic (Acoustic Sim V2) VR.mp3": "sexL",
	"./amp/Boosted Brown.jpg": "HMs/",
	"./amp/Boosted Brown4Web.mp3": "U3G9",
	"./amp/Crunch (87 Jubilee) VR.mp3": "NYOS",
	"./amp/High gain (Modded Mark II C) VR.mp3": "VrU4",
	"./amp/Low gain (PhD Z V2) VR.mp3": "C26/",
	"./amp/cab-IRs.png": "7yUR",
	"./amp/cab-celestion.png": "hKS1",
	"./amp/cab-dualmic.png": "EleD",
	"./cab-IRs.png": "g5OR",
	"./cab-celestion.png": "ncKe",
	"./cab-dualmic.png": "UPSL",
	"./cab/cab-IRs.jpg": "DTUQ",
	"./cab/cab-celestion.jpg": "AROO",
	"./cab/cab-dualmic.jpg": "XeXi",
	"./guitar-match.png": "Y0Ms",
	"./guitar-match/01-Vintage-57.jpg": "WCu2",
	"./guitar-match/02-Classic-T.jpg": "erkX",
	"./guitar-match/03-V-type.jpg": "NVNu",
	"./guitar-match/04-Classic-S.jpg": "MqAZ",
	"./guitar-match/05-JM-type.jpg": "ypkd",
	"./guitar-match/06-Country-Hollow.jpg": "CM0B",
	"./guitar-match/07-modern-S.jpg": "arHz",
	"./guitar-match/Classic Country Hollow Guitar Match off VR.mp3": "mty8",
	"./guitar-match/Classic Country Hollow VR.mp3": "SsyH",
	"./guitar-match/Classic S Guitar Match off VR.mp3": "M8Zg",
	"./guitar-match/Classic S VR.mp3": "Se4l",
	"./guitar-match/Classic T Guitar Match off VR.mp3": "P2YV",
	"./guitar-match/Classic T VR.mp3": "6ZiR",
	"./guitar-match/Modern S Guitar Match off VR.mp3": "ZYoP",
	"./guitar-match/Modern S VR.mp3": "AUqv",
	"./guitar-match/Modern SHR Guitar Match off VR.mp3": "CV07",
	"./guitar-match/Modern SHR VR.mp3": "DlKi",
	"./guitar-match/Modern V Guitar Match off VR.mp3": "b3pr",
	"./guitar-match/Modern V VR.mp3": "15ZP",
	"./guitar-match/Vintage 57 Guitar Match off VR.mp3": "TFfs",
	"./guitar-match/Vintage 57 VR.mp3": "r1x4",
	"./guitar-strat.png": "eFzn",
	"./hd-racks/Advance Compressor VR.mp3": "YFfo",
	"./hd-racks/Multi Compressor HD VR.mp3": "BPMf",
	"./hd-racks/Rotary VR.mp3": "LMCi",
	"./hd-racks/Spring Reverb HD VR.mp3": "eeVl",
	"./hd-racks/Tri Chorus HD VR.mp3": "o2/C",
	"./hd-racks/Wah HD VR.mp3": "DNxe",
	"./modeler/Delay Modeler High Gain VR.mp3": "PjBJ",
	"./modeler/Delay Modeler Low Gain VR.mp3": "beuz",
	"./modeler/Delay Modeler Mid Gain VR.mp3": "8oj2",
	"./modeler/Fuzz Modeler High Gain VR.mp3": "nB7a",
	"./modeler/Fuzz Modeler Low Gain VR.mp3": "aPL8",
	"./modeler/Fuzz Modeler Mid Gain VR.mp3": "ESVV",
	"./modeler/Harmonizer Modeler High Gain VR.mp3": "YGn3",
	"./modeler/Harmonizer Modeler Low Gain VR.mp3": "yvNO",
	"./modeler/Harmonizer Modeler Mid Gain VR.mp3": "U8xz",
	"./modeler/modeler-fuzz.jpg": "1WBu",
	"./modeler/modeler-harmonizer.jpg": "bGGM",
	"./modeler/modeler-time.jpg": "Rp3L",
	"./pedal/Boost (BIAS Preamp) VR.mp3": "wHu1",
	"./pedal/Delay (Slapback delay) VR.mp3": "3bt/",
	"./pedal/Distortion (Dumble clean) VR.mp3": "nLFL",
	"./pedal/Modulation (Lush Ensemble) VR.mp3": "7v0D",
	"./pedal/Reverb (Ambient reverb) VR.mp3": "0kHu",
	"./pedals-boost.png": "D0Y7",
	"./pedals-compressor.png": "vJYn",
	"./pedals-delay.png": "56mw",
	"./pedals-distortion.png": "oqao",
	"./pedals-eq.png": "yJVV",
	"./pedals-gate.png": "Wh3w",
	"./pedals-modulation.png": "osgw",
	"./pedals-reverb.png": "19lt"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ifmg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page ^\.\/.*$
// module id = ifmg
// module chunks = 13